export default "__VITE_ASSET__Djfw3WW8__"